import React from 'react';
import NoticeDetail from '../components/setting/NoticeDetail';

const NoticeDetailPage: React.FC = () => {
  return (
    <div className="main-container">
      <NoticeDetail />
    </div>
  );
};

export default NoticeDetailPage;
